import { render, staticRenderFns } from "./APSaleOrderDetail.vue?vue&type=template&id=93a85010&"
import script from "./APSaleOrderDetail.vue?vue&type=script&lang=js&"
export * from "./APSaleOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./APSaleOrderDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "APSaleOrderDetail.vue"
export default component.exports